import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { PortServiceItemDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { portServiceToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addPortServicesToMap(
  map: Map,
  services: PortServiceItemDto[],
): void {
  const source = findSourceByTitle(map, LayerTitle.PortServices);
  if (!source) return;
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  services.forEach((e) => {
    // Convert to internal type
    const convertedItem = portServiceToMapItem(e);
    if (!e.location) return;
    const transformed = [e.location.x, e.location.y];
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedItem });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedItem.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}

export function removeAllPortServicesFromMap(map: Map): void {
  const source = findSourceByTitle(map, LayerTitle.PortServices);
  if (!source) return;
  source.clear();
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
